import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export default function generateDataExcel(facesSelect, i18n, info) {
  const dataExcel = [];
  const heading = {
    dispo: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.dispo'),
    reference: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.reference'),
    codeReseau: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.codeReseau'),
    reseauLibelle: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.reseauLibelle'),
    dateDepart: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.dateDepart'),
    code: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.panneau'),
    format: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.format'),
    materielType: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.materiel'),
    adresse: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.adresse'),
    codePostal: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.codePostal'),
    ville: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.ville'),
    restriction: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.restriction'),
    affecteLogistiquement: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.affecteLogistiquement'),
    latitude: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.latitude'),
    longitude: i18n.t('exportExcelFaceSelectInReseauTempoForReseauPerso.columnExcel.longitude'),
  };
  if (!info.displayColumnLogistique) delete heading.affecteLogistiquement;
  dataExcel.push(heading);
  facesSelect.forEach((face) => {
    const ligneExcel = {
      dispo: face.dispo ? i18n.t('general.oui') : i18n.t('general.non'),
      reference: face.reference,
      codeReseau: face.codeReseau,
      reseauLibelle: face.reseauLibelle,
      dateDepart: face.dateDepart,
      code: face.codePanneau,
      format: face.format,
      materielType: face.materielType,
      adresse: adressFullStringGetter(face.adresse, true),
      ville: face.adresse.ville,
      codePostal: face.adresse.codePostal,
      restriction: face.restriction,
      affecteLogistiquement: info.affectationLogistiqueAlreadyDone && (face.affecteLogistiquement) ? i18n.t('general.oui') : i18n.t('general.non'),
      latitude: face.adresse.latitude,
      longitude: face.adresse.longitude,
    };
    if (!info.displayColumnLogistique) delete ligneExcel.affecteLogistiquement;
    dataExcel.push(ligneExcel);
  });
  return dataExcel;
}
